import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EPropertyForRentStatus } from "@rentiohq/shared-frontend/dist/types/property.types";
import { EField, IExtraData } from "./schema.editPropertyInfo.types";

export const getInitialValues = ({
  property,
  roomCountBathroom,
  roomCountGarage,
  buildingSurfaceArea,
}: IExtraData): IValues => {
  return {
    [EField.Costs]: property.costs,
    [EField.Price]: property.price,
    // Default the publish choice only when it was never set: a property that
    // is "for rent" defaults to Publish (the broker's likely intent), anything
    // else defaults to Do-not-publish. An explicit stored value is respected.
    [EField.IsRentMatchPublished]:
      property.isRentMatchPublished ??
      property.forRentStatus === EPropertyForRentStatus.ForRent,
    [EField.RoomCountBedroom]: property.roomCountBedroom,
    [EField.AvailableAtDate]: property.availableAtDate
      ? new Date(property.availableAtDate)
      : null,
    [EField.ExternalListingUrl]: property.externalListingUrl ?? null,
    // Extra property details — step 2 (amenity-sourced, not on IProperty directly)
    [EField.RoomCountBathroom]: roomCountBathroom ?? null,
    [EField.RoomCountGarage]: roomCountGarage ?? null,
    [EField.BuildingSurfaceArea]: buildingSurfaceArea ?? null,
    // Direct property fields
    [EField.EpcLabel]: property.epcLabel ?? null,
    [EField.BuildingTerraceSurfaceArea]:
      property.buildingTerraceSurfaceArea ?? null,
    [EField.BuildingGardenSurfaceArea]:
      property.buildingGardenSurfaceArea ?? null,
  };
};
